module.exports = __webpack_public_path__ + "img/hunt_emj.c773c340.png";